import { OldPortfolioController } from './oldPortfolio.controller';
import template from './oldPortfolio.html';

export const oldPortfolioComponent = {
  name: 'oldPortfolioComponent',
  restrict: 'E',
  template,
  controller: OldPortfolioController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.component.js